<script>
import { mapState } from 'vuex';
import DepService from "@/api/services/depService";
export default {
  computed: {
    ...mapState(["user", "serviceId", "productId",]),

    currentCoins() {
      return this.$route.query.coins || 0;
    }

  },
  methods: {
    goToTerms() {
      this.$router.push({
        path: '/terms',
        query: { coins: this.currentCoins }
      });
    },
    cancel() {
      const coins = this.currentCoins;

      this.$store.commit('setRegularGameCoins', parseInt(coins));
      this.$router.go(-1);
    },

    async confirmSubscription() {
      try {
        const serviceId = 10589;
        const response = await DepService.doiOne(
            this.user.msisdn,
            serviceId,
            this.productId
        );

        if(response.data.result) {
          this.$router.push({
            path: '/doi-success',
            query: { coins: this.currentCoins }
          });
        } else {
          return;
        }

      } catch (error) {
        console.error("Error confirming subscription:", error);
      }
    }
  },
  beforeMount() {
    console.log("Component mounted.")
  }
};

</script>

<template>
<div class="containerBg d-flex flex-column justify-content-start align-items-center col-12">

  <div class = "d-flex justify-content-center align-items-center ">
    <img src = "@/assets/upsell/yello-rush-upsell.png" class = "col-6 mt-5"  />
  </div>

  <div class = "d-flex justify-content-center align-items-center bold mt-5 ">Please confirm your</div>
  <div class = "d-flex justify-content-center align-items-center bold">subscription to Y’ello Rush</div>

  <div class = "d-flex justify-content-center align-items-center normalText mt-3">R5/day. Subscription service</div>
  <div class = "d-flex justify-content-center align-items-center normalText">FIRST DAY FREE</div>

  <div class="d-flex flex-column justify-content-center align-items-center text-center col-12 mt-5">
    <div class="playButton playText p-3 col-11 yes" @click = confirmSubscription>Yes</div>
  </div>

  <div class = "d-flex justify-content-center align-items-center mt-4 backbut" @click = cancel>Cancel</div>

  <div class ="d-flex flex-column col-12 tcs">
    <div class = "d-flex justify-content-center align-items-center normalText mt-3 ">R5/day. Subscription service. </div>
    <div class = "d-flex justify-content-center align-items-center texttcs " @click = goToTerms>Terms and Conditions  </div>
  </div>


</div>
</template>

<style scoped>

.containerBg {
  position: relative;
  min-height: 100vh ;
  background-image: url('@/assets/upsell/upsell-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
}

.yes{
  font-weight: 600;
  font-size: 19px;
}

.playButton{
  background-color: #FFCB05;
  border-radius: 30px;
}
.backbut{
  font-weight: 600;
  font-size: 16px;
  color: #000F56;
  text-decoration: underline;

}

.texttcs{
  text-decoration: underline;
  color: #007AFF;
  font-weight: 400;
  font-size: 15px;
}

.normalText{
  font-weight: 400;
  font-size: 15px;
  color: #000F56;
}

.bold{
  font-weight: 600;
  font-size: 17px;
  color: #000F56;
}

.tcs{
  position: absolute;
  bottom: 5%;
}



</style>